/** global localStorage */
import AuthService from '../../services/AuthService'
import MeService from '../../services/MeService'
import TelegramService from '../../services/TelegramService'

const state = {
  user: null,
  jwt: localStorage.getItem('jwt') || ''
}

const mutations = {
  SET_JWT (state) {
    state.jwt = localStorage.getItem('jwt')
  },
  SET_USER (state, user) {
    state.user = user ? {
      ...state.user,
      ...user
    } : null

    if (window.gtag) {
      if (user) {
        window.gtag('set', { user_id: user.id, crm_id: user.id })
      } else {
        window.gtag('set', { user_id: null, crm_id: null })
      }
    }

    if (window.clarity) {
      if (user) {
        window.clarity('set', 'user_id', user.id)
        window.clarity('set', 'user_email', user.email)
      }
    }
  },
  SET_TEAM (state, team) {
    state.user.team = team
  }
}

const actions = {
  async fetchUser ({ commit, rootState, dispatch }) {
    let user = null

    try {
      user = await MeService.show()
    } catch (e) {
      if (rootState.auth.jwt) {
        dispatch('logout')
        window.location.reload()
      }
    }

    commit('SET_USER', user)

    return user
  },
  async fetchAffiliate ({ commit }) {
    let data = null

    try {
      data = await MeService.show('affiliate')
      commit('SET_USER', data)
    // eslint-disable-next-line no-empty
    } catch (e) {}

    return data
  },
  async update ({ commit }, data) {
    const user = await MeService.update('', data)
    commit('SET_USER', user)
    return user
  },
  async login ({ dispatch, commit }, { type, utm_source, plan }) {
    return new Promise((resolve, reject) => {
      if (type === 'facebook') {
        window.FB.login(async (response) => {
          let data = null
          if (response.status === 'connected') {
            data = await AuthService.facebook({ utm_source, plan, accessToken: response.authResponse.accessToken })
            const user = await dispatch('fetchUser')

            commit('SET_JWT')
            commit('SET_USER', user)

            return resolve(data)
          } else {
            dispatch('logout')
            return reject(response.status)
          }
        }, { scope: 'email' })
      } else if (type === 'google') {
        window.auth2.isSignedIn.listen(authenticated => {
          if (!authenticated) {
            reject(authenticated)
          }
        })

        window.auth2.currentUser.listen(async googleUser => {
          if (googleUser) {
            let data = null
            try {
              data = await AuthService.google({ utm_source, plan, accessToken: googleUser.getAuthResponse().id_token })
            } catch (e) {
              window.alert(e.message)
              window.location.reload()
              return reject(e.message)
            }

            const user = await dispatch('fetchUser')

            commit('SET_JWT')
            commit('SET_USER', user)

            return resolve(data)
          }

          window.location.reload()
        })

        window.auth2.signIn()
      }
    })
  },
  async logout ({ commit }) {
    AuthService.logout()
    commit('SET_JWT')
    commit('SET_USER', null)
    window.FB.logout()
    return window.location.reload()
  },
  async getTelegramCode ({ commit }) {
    const data = await TelegramService.show('/code')
    commit('SET_USER', data)
    return data
  },
  async revokeTelegram ({ commit }) {
    const data = await TelegramService.show('/revoke')
    commit('SET_USER', data)
    return data
  },
  async acceptTerms ({ commit }) {
    const data = await MeService.show('/accept-terms')
    commit('SET_USER', data)
    return data
  },
  async activateTrial ({ commit }, id) {
    const data = await MeService.show(`/activate-trial?plan_id=${id}`)
    commit('SET_USER', data)
    return data
  },
  removeAccount () {
    return MeService.store('remove-account')
  },
  exportMyData () {
    return MeService.store('export-my-data')
  },
  sendQuestion (_, data) {
    return MeService.store('send-question', data)
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
